import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { forwardRef, useContext } from 'react';
import PropTypes__default from 'prop-types';
import { AutocompleteContext, AutocompleteOptionsContext } from '../autocomplete-context.js';
import Text from '../../text/text.js';

var AutocompleteOption = /*#__PURE__*/forwardRef(function (_a, ref) {
  var bem = _a.bem,
    optionHasSubtitle = _a.optionHasSubtitle,
    renderOption = _a.renderOption,
    option = _a.option,
    rest = __rest(_a, ["bem", "optionHasSubtitle", "renderOption", "option"]);
  var _b = useContext(AutocompleteContext),
    containerId = _b.containerId,
    focusableOptions = _b.focusableOptions,
    focusedOption = _b.focusedOption;
  var _c = useContext(AutocompleteOptionsContext).onOptionSelect,
    onOptionSelect = _c === void 0 ? function () {
      return null;
    } : _c;
  var isSelected = focusableOptions && option === focusableOptions[focusedOption];
  return /*#__PURE__*/React__default__default.createElement("li", __assign({}, rest, {
    id: "".concat(containerId, "-option-").concat(focusableOptions === null || focusableOptions === void 0 ? void 0 : focusableOptions.indexOf(option)),
    role: "option",
    "aria-selected": isSelected,
    className: bem.e('option', {
      'single-line': !optionHasSubtitle
    }),
    ref: ref,
    onClick: function () {
      return onOptionSelect(option, focusableOptions.indexOf(option));
    }
  }), renderOption ? renderOption(option) : /*#__PURE__*/React__default__default.createElement(React__default__default.Fragment, null, /*#__PURE__*/React__default__default.createElement(Text, {
    extraClasses: bem.e('title')
  }, option.title), optionHasSubtitle && /*#__PURE__*/React__default__default.createElement(Text, {
    extraClasses: bem.e('subtitle')
  }, option.subtitle || '')));
});
var AutocompleteOptionPropTypes = PropTypes__default.shape({
  title: PropTypes__default.string.isRequired,
  subtitle: PropTypes__default.string,
  key: PropTypes__default.string
});

export { AutocompleteOption, AutocompleteOptionPropTypes };
